import type { FeatureFlags } from '../feature-flags'

/**
 * An experimental set of {@link FeatureFlags} that have not been well
 * tested/reviewed
 */
export const EXPERIMENTAL: FeatureFlags = {
  agentCore: {
    bch: true,
    deckOrchestrator: true,
    dms: true,
    dmsQueryGenerator: true,
    dmsSchemaAssistant: true,
    guide: true,
    naming: true,
    pptGenerator: true,
    proposalGenerator: true,
  },
  policyMe: false,
  writingHelper: true,
}
